<template>
  <div class="create-task-upload">
    <el-upload
      ref="upload"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="onUploadChange"
      action="#">
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'createTask',
  methods: {
    //拉起文件选择器，供父组件调用
    open() {
      this.$refs['upload'].$refs['upload-inner'].handleClick()
    },
    //选择文件后直接创建任务
    onUploadChange(item) {
      if (!item.raw) {
        return
      }
      this.submitCreate(item.raw)
    },
    //提交创建任务
    submitCreate(file) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('token', localStorage.getItem('Token'));
      this.$apis.importTaskServer.createTask(formData).then(res => {
        if (res['code'] == 0) {
          this.$message.success('创建任务成功')
          this.$emit('update');
        }
      })
      this.$refs['upload'].clearFiles();
    },
  }
};
</script>

<style scoped lang="scss">
.create-task-upload {
  display: none;
}
</style>
